export default {
  ADD: 'ADD',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  CANCEL: 'CANCEL',
  DOWNLOAD: 'DOWNLOAD',
  VIEW: 'VIEW',
  DUPLICATE: 'DUPLICATE',
};
